<template lang="pug">
article
  .dark-background(ref="darkBg")
  header(ref="header") {{article.shortText || article.text}}
  main(ref="main" @click="goToStores")
    div
      .text {{article.text}}
    div
      .text
        | at {{airport.terminal}}
        i.right-arrow
  footer(ref="footer") {{article.shortText || article.text}}
  .arrow.up(@click="goToPrevious" ref="arrowUp")
  .arrow.down(@click="goToNext" ref="arrowDown")
</template>

<script>
export default {
  props: {
    article: {
      default: () => {},
      type: Object,
    },
    airport: {
      default: () => {},
      type: Object,
    },
    first: {
      default: false,
      type: Boolean,
    },
    last: {
      default: false,
      type: Boolean,
    },
    index: {
      default: 0,
      type: Number,
    },
  },
  beforeMount() {
    window.addEventListener('scroll', this.scrollFunction);
    window.addEventListener('resize', this.scrollFunction);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollFunction);
    window.removeEventListener('resize', this.scrollFunction);
  },
  mounted() {
    this.scrollFunction();
  },
  methods: {
    scrollFunction() {
      const elHeight = this.$el.clientHeight;
      const elTop = this.$el.getBoundingClientRect().top;
      const winHeight = window.innerHeight;
      const elBottom = elTop + elHeight;
      const elMiddle = elTop + elHeight / 2;
      const viewTop = document.getElementsByTagName('header')[0].offsetHeight;
      const viewHeight = winHeight - viewTop;
      const viewMiddle = viewTop + viewHeight / 2;

      if ((window.innerWidth < 825 && window.innerWidth > window.innerHeight)
        || window.innerWidth < 700) {
        this.$refs.darkBg.style.opacity = 0;
        this.$refs.main.style.right = 0;
        this.$refs.main.style.top = '50%';
        this.$refs.main.style.transform = 'translateY(-50%)';
        if (!this.$el.classList.contains('shops')) {
          this.$el.style.backgroundPositionY = '50%';
        }
        return;
      }

      // Parallax
      const parDelta = elBottom - winHeight;
      let rate = parDelta / elHeight;
      rate *= 200;
      if (rate < 0) {
        rate = 0;
      }

      if (!this.$el.classList.contains('shops')) {
        this.$el.style.backgroundPositionY = `${rate}%`;
      }


      // Down arrow animation
      if (elBottom <= viewMiddle) {
        let delta = (viewMiddle - elBottom) / 120;
        if (delta < 0) {
          delta = 0;
        }
        if (delta > 1) {
          delta = 1;
        }
        this.$refs.arrowDown.style.opacity = 1 - delta;
      }

      // Up arrow animation
      if (elTop >= viewTop && !this.last) {
        let delta = (elTop - viewTop) / 120;
        if (delta < 0) {
          delta = 0;
        }
        if (delta > 1) {
          delta = 1;
        }
        this.$refs.arrowUp.style.opacity = 1 - delta;
      }

      // Header animation
      if (elTop <= viewTop + elHeight) {
        let delta = viewTop + elHeight - elTop;

        if (delta < 0) {
          delta = 0;
        }

        if (delta < 90) {
          this.$refs.header.style.marginTop = `${delta / 2}px`;
          this.$refs.header.style.marginBottom = `${delta / 2}px`;
          this.$refs.header.style.right = '0px';
        } else {
          this.$refs.header.style.right = `${(90 - delta) * 6}px`;
        }
      }

      // Footer animation
      if (elBottom >= viewTop) {
        let delta = elBottom - viewTop - (viewHeight - elHeight);

        if (delta < 0) {
          delta = 0;
        }

        if (delta < 90) {
          this.$refs.footer.style.marginTop = `${delta / 2}px`;
          this.$refs.footer.style.marginBottom = `${delta / 2}px`;
          this.$refs.footer.style.right = '0px';
        } else {
          this.$refs.footer.style.right = `${(90 - delta) * 6}px`;
        }
      }

      // Main animation
      if (elBottom < winHeight) {
        const delta = winHeight - elBottom;
        const maxDistance = viewHeight - elHeight;
        let pos = (maxDistance - delta) / maxDistance;
        if (pos < 0) {
          pos = 0;
        }
        const posP = (1 + pos) / 2 * 100;
        this.$refs.main.style.top = `${posP}%`;
        this.$refs.main.style.transform = `translateY(-${50 * (1 - pos)}%)`;
      }

      if (elTop <= viewTop - 120) {
        const delta = elTop - viewTop + 120;
        this.$refs.main.style.right = `${delta * 6}px`;
      } else {
        this.$refs.main.style.right = 0;
        this.$refs.main.style.top = '50%';
        this.$refs.main.style.transform = 'translateY(-50%)';
      }

      // Dark background animation
      let opacity =
        (Math.abs(viewMiddle - elMiddle) - 160) /
        ((viewHeight + elHeight) / 2) *
        2;
      if (opacity < 0) {
        opacity = 0;
      }
      if (opacity > 1) {
        opacity = 1;
      }
      this.$refs.darkBg.style.opacity = opacity;

      if (opacity < 0.1) {
        this.$emit('in-viewport', this.index);
      }
    },
    goToPrevious() {
      this.$emit('go-to-previous');
    },
    goToNext() {
      this.$emit('go-to-next');
    },
    goToStores() {
      this.$emit('go-to-stores');
    },
  },
};
</script>

<style lang="stylus" scoped>
@import url('../../static/fonts/rift/stylesheet')

*
  font-family 'Rift Soft'

article
  height var(--article-height)
  position relative
  background-size cover
  background-repeat no-repeat
  overflow hidden

  &.dine
    background-image url('../../static/images/dine.jpg')

  &.shops
    background-image url('../../static/images/shops.jpg')

  &.services
    background-image url('../../static/images/services.jpg')

  &.offers
    background-image url('../../static/images/offers.jpg')

  &:first-of-type
    margin-top var(--main-header-height)
    background-position 47% 53%
    background-size 95%
    background-repeat repeat

    header
      opacity 0

    .arrow.up
      display none

    .dark-background
      opacity 0

    main
      top 50%
      transform translateY(-50%)

  &:last-of-type
    footer, header
      opacity 0

    main
      top 50%
      transform translateY(-50%)

    .arrow.down
      display none

    .arrow.up
      opacity 1
      background-image url('../../static/images/icon-arrow-dark.png')
      transform translateX(0) scaleY(1)

  .dark-background
    position absolute
    top 0
    right 0
    left 0
    bottom 0
    background-color rgba(0, 0, 0, .58)

  header, main, footer
    text-align right
    position absolute
    right 0
    margin-right var(--article-title-right)
    font-weight 100

  header, footer
    font-size var(--article-header-font-size)
    color white
    font-weight 100
    line-height var(--article-header-line-height)

  main
    cursor pointer

  footer
    bottom 0

  main
    font-size var(--article-main-font-size)
    top 100%
    max-width 280px

    .text
      display inline
      line-height var(--article-main-line-height)
      background rgba(4, 4, 4, .55)
      color white
      padding 0 8px

  .arrow
    position absolute
    left 50%
    background-image url('../../static/images/icon-arrow.png')
    background-size 100% 100%
    width 60px
    height 35px
    margin 10px 0
    cursor pointer

    &.up
      transform translateX(0) scaleY(-1)
      opacity 0

    &.down
      bottom 0

  i
    &.right-arrow
      display inline-block
      width 0
      height 0
      border-top var(--article-icon-border) solid transparent
      border-bottom var(--article-icon-border) solid transparent
      border-left var(--article-icon-border) solid white
      margin-left var(--article-icon-left)
      vertical-align middle

  @media screen and (max-width 1024px)
    .arrow
      &.up
        display block
      &.down
        display block

  @media screen and (max-width 900px)
    &:first-of-type
      background-position 33% 53%
      background-size cover

  @media screen and (max-width: 825px) and (orientation: landscape)
    header
      display none

    footer
      display none

  @media screen and (max-height: 500px) and (orientation: landscape)
    background-position 0% 50%

  @media screen and (max-width 700px) and (orientation portrait)
    header
      display none

    footer
      display none

    .arrow
      &.up
        display none
      &.down
        display none

  @media screen and (max-height 500px) and (orientation landscape)
    .arrow
      &.up
        display none
      &.down
        display none

  @media screen and (max-height 400px) and (orientation landscape)
    header
      display none

    footer
      display none

  @media screen and (max-width 350px)
    &:first-of-type
      background-position 25% 53%
      background-size cover

</style>



// WEBPACK FOOTER //
// src/components/ExploreArticle.vue